import { render } from "./AdminGuide.vue?vue&type=template&id=40cda95e"
import script from "./AdminGuide.vue?vue&type=script&lang=js"
export * from "./AdminGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__